import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import jwtDecode from "jwt-decode";

import createPersistedState from 'vuex-persistedstate';
// eslint-disable-next-line
import MainStore from './main/MainStore';
import CartStore from './CartStore';

import { Models } from 'sr-js-lib';

import {
  login,
  signup,
  resendPin,
  validatePin,
  forgotPassword,
  recoverPassword,
  updateUser,
  getMyOrders,
  changePassword,
  deleteOrder,
  updateUserAddress,
  getMe,
  updateOrderReview,
} from '@/api/index'


Vue.use(Vuex);

const initialState = () => ({
  viewStore: true,
  logged: false,
  user: {},
  prevRoute: {},
  zipCodeModal: false,
  invalidAddressModal: false,
  forms: {
    user: false,
    address: false,
    password: false,
  },
  orderList: [],
  showMenu: false,
  loading: {
    review: false,
  },
  cart_notes: '',
  showCouponsModal: false,
  isCheckout: false,
  showWAMessage: false,
});

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    ...initialState()
  },
  mutations: {

    setZipCodeModal(state, status) {
      state.zipCodeModal = status;
    },
    setCouponsModal(state, status) {
      state.showCouponsModal = status;
    },
    setIsCheckout(state, status) {
      state.isCheckout = status;
    },
    setInvalidAddressModal(state, status) {
      state.invalidAddressModal = status;
    },
    setUser(state, user) {
      state.user = user;
    },
    setLogged(state, logged) {
      state.logged = logged;
    },
    setPrevRoute(state, prevRoute) {
      state.prevRoute = prevRoute;
    },
    setForm(state, form) {
      state.forms = {
        ...state.forms,
        ...form
      };
    },
    setOrders(state, orderList) {
      state.orderList = orderList;
    },
    setOrder(state, order) {
      let index = state.orderList.findIndex( item => item._id == order._id);
      state.orderList[index].status = order.status;
      state.orderList[index].cancelation_notes = order.cancelation_notes;
      state.orderList[index].canceled_by_customer = order.canceled_by_customer;
      state.orderList[index].canceled_by = order.canceled_by;
    },

    reset(state) {
      state.CartStore.cartProducts = Models.M_cart();
      state.Main.adminOrder = false;
      state.Main.validAddress = false;
      state.Main.initialAddress= Models.M_customer();
      Object.assign(state, {
        ...initialState()
      });
      localStorage.clear();
      setTimeout(() => {
        router.push('/').catch(()=>{});
      }, 200);
    },
    setMenuVisibility(state, boolSate){
      state.showMenu = boolSate;
    },
    setLoading(state, loading) {
      state.loading = {
        ...state.loading,
        ...loading
      };
    },
    orderReview(state, order) {
      let index = state.orderList.findIndex( item => item._id == order._id);
      state.orderList[index].review = order.review;
    },
    setCartNotes(state, notes){
      state.cart_notes = notes;
    },
    setShowWAMessage(state, show){
      state.showWAMessage = show;
    },
  },
  actions: {
    reset(context) {
      context.commit('reset');
    },
    async fnApiSetAdminOrder(context, jwt){
      const decoded = jwtDecode(jwt);
      const user = decoded.identity;
      localStorage.setItem("jwt", jwt);
      localStorage.setItem("exp", decoded.exp);
      context.commit('setUser', user);

      context.state.Main.adminOrder = true;
      context.state.Main.initialAddress= user;

      context.state.Main.validAddress = true;
      let store = context.state.Main.storeList.find(x => x.store_id == user.store_id);
      if(store){
        context.state.Main.currentStore = store;
      }

      await context.dispatch('CartStore/fnApiGetCart');
      setTimeout(() => {
        context.state.viewStore = true;
        router.push('/');
      }, 200);
    },
    async fnApiLogin(context, {
      phone,
      password,
      redirect,
    }) {
      await login({
        phone,
        password
      }).then(async res => {
        const decoded = jwtDecode(res.jwt);
        const user = decoded.identity;
        localStorage.setItem("jwt", res.jwt);
        localStorage.setItem("exp", decoded.exp);
        context.commit('setUser', user);

        context.state.Main.adminOrder = false;
        context.state.Main.initialAddress= user;

        //if(context.state.Main.validAddress == false && user.store_id && user.address){
        if(user.store_id && user.address){
          context.state.Main.validAddress = true;
          let store = context.state.Main.storeList.find(x => x.store_id == user.store_id);
          if(store){
            context.state.Main.currentStore = store;
          }
        }

        await context.dispatch('CartStore/fnApiGetCart');
        setTimeout(() => {
          if( redirect ){
            router.push(redirect);
          }else{
            router.push('/');
          }
        }, 200);
      }).catch(err => {
        if(err.response.data.error_code == 12){
          let link = `/payment/change-password?pin_required=true&phone=${phone}`;
          if(redirect){
            link += `&redirect=${redirect}`;
          } 
          router.push(link);
        }
      });
    },
    async fnApiSignup(context, [userData,redirect]) {
      let link = `/payment/change-password?pin_required=true&phone=${userData.phone}`;
      
      await signup(userData).then(res => {
        setTimeout(() => {
          if( redirect ){
            link += `&redirect=${redirect}`;
          }
          router.push(link);
        }, 200);
      }).catch(err => {
        if (err.response.data.error_code == 108) {
          router.push(link);
        }
      });
    },

    async fnApiResendPin(context, phone) {
      await resendPin(phone).then(res => {
      }).catch((e) => {});
    },

    async fnApiValidatePin(context, [phoneData,redirect]) {
      await validatePin(phoneData).then(async res => {
        const decoded = jwtDecode(res.jwt);
        const user = decoded.identity;
        localStorage.setItem("jwt", res.jwt);
        localStorage.setItem("exp", decoded.exp);
        context.commit('setUser', user);
        await context.dispatch('CartStore/fnApiGetCart');
        setTimeout(() => {
          if( redirect ){
            router.push(redirect);
          }else{
            router.push('/');
          }
        }, 200);
      }).catch((e) => {});
    },

    async fnApiForgotPassword(context, [phone,redirect]) {
      await forgotPassword(phone).then(res => {
        let link = `/payment/change-password?change_password=true&phone=${phone}`;
        if(redirect){
          link += `&redirect=${redirect}`;
        } 
        router.push(link);
      }).catch(err => {
        if(err.response.data.error_code == 12){
          let link = `/payment/change-password?pin_required=true&phone=${phone}`;
          if(redirect){
            link += `&redirect=${redirect}`;
          } 
          router.push(link);
        }
      });
    },

    async fnApiRecoverPassword(context, [data,redirect]) {
      await recoverPassword(data).then(res => {
        let link = `/payment/signin`;
        if( redirect ){
          link += `?redirect=${redirect}`;
        }
        router.push(link);
      });
    },

    async fnApiUpdateUser(context, data) {
      await updateUser(data).then(res => {
        context.commit('setUser', res);
        context.commit('setForm', {
          user: false
        });
      }).catch((e) => {});
    },

    async fnApiGetMe(context) {
      await getMe().then(res => {
        context.commit('setUser', res );
      }).catch((e) => {});
    },

    async fnApiGetOrders(context, data) {
      await getMyOrders(data).then(res => {
        context.commit('setOrders', res);
      }).catch((e) => {});
    },

    async fnApiChangePassword(context, [data, callback]) {
      await changePassword(data).then(res => {
        callback();
      }).catch((e) => {});
    },

    async fnApiDeleteOrder(context, [orderId, notes,callback]) {
      await deleteOrder(orderId,notes).then(res => {
        context.commit('setOrder', res );
        if( callback ) {
          callback();
        }
      }).catch((e) => {});
    },

    async fnApiUpdateUserAddress(context, [body,callback]) {
      await updateUserAddress(body).then(res => {
        context.commit('setUser', res );
        callback();
      }).catch((e) => {});
    },

    async fnApiUpdateOrderReview(context, [body,callback]) {
      context.commit('setLoading', {
        review: true
      });
      let orderId = body.orderId;
      delete body.orderId;
      await updateOrderReview(orderId,body).then(res => {
        context.commit('orderReview', res );
        callback();
      }).catch((e) => {});
      context.commit('setLoading', {
        review: false
      });
    }

  },
  modules: {
    Main: MainStore,
    CartStore: CartStore
  },
});
